var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconReceived = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 18L11.25 15L12.41 13.84L14 15.43L17.59 11.84L18.75 13.25M9.8 18H2C0.89 18 0 17.11 0 16V2C0 0.89 0.89 0 2 0H16C17.11 0 18 0.89 18 2V9.8C17.39 9.45 16.72 9.2 16 9.08V2H2V16H9.08C9.2 16.72 9.45 17.39 9.8 18ZM9 14H4V12H9M11.68 10H4V8H14V9.08C13.15 9.22 12.37 9.54 11.68 10ZM14 6H4V4H14",
    fill: "#0DAB01"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconReceived);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_received.213944a824138b454ef33388925c336f.svg";